<div class="condition-wrapper">
  @if (conditionIndex && conditionIndex > 0) {
    <mat-select
      [(ngModel)]="selectedTransitionOperator"
      (selectionChange)="transitionChange()"
      placeholder="Operator"
      class="question-operator-input"
    >
      <mat-option selected value="and">And</mat-option>
      <mat-option value="or">Or</mat-option>
    </mat-select>
  }

  <div cdkDrag class="condition-container grabbable">
    <div class="drag-icon">
      <mat-icon>drag_indicator</mat-icon>
    </div>

    @if (condition) {
      <div class="drag-inputs">
        <mat-select
          [(ngModel)]="selectedQuestion"
          (ngModelChange)="selectProperty()"
          placeholder="Select Question"
          class="question-input"
          [ngClass]="{ 'question-input-without-value': !selectedQuestion }"
        >
          <mat-option>None</mat-option>
          @for (question of questions; track question) {
            <mat-option [value]="question">{{ question.title }}</mat-option>
          }
        </mat-select>

        <mat-select
          [(ngModel)]="selectedOperator"
          (ngModelChange)="selectOperator()"
          placeholder="Select Operator"
          class="question-input-operator"
          [ngClass]="{ 'question-input-operator-wo-value': !selectedOperator }"
        >
          <mat-option>None</mat-option>
          @for (operator of operatorList; track operator) {
            <mat-option [value]="operator">{{ operator }}</mat-option>
          }
        </mat-select>

        @if (!condition.operator || condition.operator.hasValue) {
          @if (questionTypeSingleSelect(selectedQuestion?.inputType)) {
            <mat-select
              [(ngModel)]="condition.value"
              placeholder="Select Answer"
              class="question-input"
              [ngClass]="{ 'question-input-without-value': !condition.value }"
            >
              <mat-option>None</mat-option>
              @for (option of selectedQuestion?.options; track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
              }
            </mat-select>
          } @else if (questionTypeInput(selectedQuestion?.inputType)) {
            <input
              type="text"
              [(ngModel)]="condition.value"
              placeholder="Select Answer"
              class="question-input"
              [ngClass]="{ 'question-input-without-value': !condition.value }"
              matInput
            />
          } @else if (questionTypeNumber(selectedQuestion?.inputType)) {
            <input
              type="number"
              inputmode="numeric"
              pattern="\d*"
              [(ngModel)]="condition.value"
              placeholder="Select Answer"
              class="question-input"
              [ngClass]="{ 'question-input-without-value': !condition.value }"
              matInput
            />
          } @else {
            <mat-select placeholder="Select Answer" class="question-input question-input-without-value">
              <mat-option>None</mat-option>
            </mat-select>
          }
        }
      </div>
    }

    <div class="close-icon">
      <mat-icon (click)="deleteCondition()">close</mat-icon>
    </div>
  </div>
</div>
